import type { Report } from "@/services/api/report-builder/types";

/**
 * Returns true when the report template defines at least one resource slot.
 * Slot assignments must be sent together in one report config, not split into one PDF per resource.
 */
export function reportHasResourceSlots(
  report: Report | null | undefined,
): boolean {
  const slots = report?.data?.resource_slots;
  return Array.isArray(slots) && slots.length >= 1;
}

/**
 * When true, the /reports single-generate download path emits one PDF per resource
 * for templates **without** resource_slots when multiple resources arrive in one callback.
 * When false, all resources in the callback belong to one config (multi-slot template,
 * or each ExportDialog batch row with a full slot set).
 */
export function shouldSplitMultiResourceDownload(
  report: Report | null | undefined,
  resourcesLength: number,
  exportType: "view" | "view-static" | "download",
): boolean {
  return (
    exportType === "download" &&
    resourcesLength > 1 &&
    !reportHasResourceSlots(report)
  );
}
